import React, { Component } from 'react'
import '../styles/UsgsCommons.scss'
import '../styles/UsgsCustom.scss'

class UsgsHeader extends Component {

  render() {
    return (
      <div className="usgs">
        <footer className="footer">
          <div className="tmp-container">
            <div className="footer-doi">
              <ul className="menu nav">
                <li className="first leaf menu-links menu-level-1"><a href="https://www.doi.gov/privacy">DOI Privacy Policy</a></li>
                <li className="leaf menu-links menu-level-1"><a href="https://www.usgs.gov/laws/policies_notices.html">Legal</a></li>
                <li className="leaf menu-links menu-level-1"><a href="https://www2.usgs.gov/laws/accessibility.html">Accessibility</a></li>
                <li className="leaf menu-links menu-level-1"><a href="https://www.usgs.gov/sitemap.html">Site Map</a></li>
                <li className="last leaf menu-links menu-level-1"><a href="https://answers.usgs.gov/">Contact USGS</a></li>
              </ul>
            </div>

            <hr/>

            <div className="footer-doi">
              <ul className="menu nav">
                <li className="first leaf menu-links menu-level-1"><a href="https://www.doi.gov/">U.S. Department of the Interior</a></li>
                <li className="leaf menu-links menu-level-1"><a href="https://www.doioig.gov/">DOI Inspector General</a></li>
                <li className="leaf menu-links menu-level-1"><a href="https://www.whitehouse.gov/">White House</a></li>
                <li className="leaf menu-links menu-level-1"><a href="https://www.whitehouse.gov/omb/management/egov/">E-gov</a></li>
                <li className="leaf menu-links menu-level-1"><a href="https://www.doi.gov/pmb/eeo/no-fear-act">No Fear Act</a></li>
                <li className="last leaf menu-links menu-level-1"><a href="https://www2.usgs.gov/foia">FOIA</a></li>
              </ul>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

export default UsgsHeader
